! function(e) {
    function a(a) {
        for (var n, s, l = a[0], r = a[1], i = a[2], c = 0, p = []; c < l.length; c++) s = l[c], Object.prototype.hasOwnProperty.call(o, s) && o[s] && p.push(o[s][0]), o[s] = 0;
        for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        for (u && u(a); p.length;) p.shift()();
        return d.push.apply(d, i || []), t()
    }

    function t() {
        for (var e, a = 0; a < d.length; a++) {
            for (var t = d[a], n = !0, l = 1; l < t.length; l++) {
                var r = t[l];
                0 !== o[r] && (n = !1)
            }
            n && (d.splice(a--, 1), e = s(s.s = t[0]))
        }
        return e
    }
    var n = {},
        o = {
            1: 0
        },
        d = [];

    function s(a) {
        if (n[a]) return n[a].exports;
        var t = n[a] = {
            i: a,
            l: !1,
            exports: {}
        };
        return e[a].call(t.exports, t, t.exports, s), t.l = !0, t.exports
    }
    s.m = e, s.c = n, s.d = function(e, a, t) {
        s.o(e, a) || Object.defineProperty(e, a, {
            enumerable: !0,
            get: t
        })
    }, s.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, s.t = function(e, a) {
        if (1 & a && (e = s(e)), 8 & a) return e;
        if (4 & a && "object" == typeof e && e && e.__esModule) return e;
        var t = Object.create(null);
        if (s.r(t), Object.defineProperty(t, "default", {
                enumerable: !0,
                value: e
            }), 2 & a && "string" != typeof e)
            for (var n in e) s.d(t, n, function(a) {
                return e[a]
            }.bind(null, n));
        return t
    }, s.n = function(e) {
        var a = e && e.__esModule ? function() {
            return e.default
        } : function() {
            return e
        };
        return s.d(a, "a", a), a
    }, s.o = function(e, a) {
        return Object.prototype.hasOwnProperty.call(e, a)
    }, s.p = "";
    var l = window.shopifySlateJsonp = window.shopifySlateJsonp || [],
        r = l.push.bind(l);
    l.push = a, l = l.slice();
    for (var i = 0; i < l.length; i++) a(l[i]);
    var u = r;
    d.push([39, 0]), t()
}({
    103: function(e, a) {},
    39: function(e, a, t) {
        "use strict";
        var n = function(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }(t(5));
        t(40), t(41), t(42), t(43), t(6), t(44), t(45), t(103);
        var o = t(46),
            d = t(102),
            s = t(25);

        function l(e) {
            var a = e;
            (0, n.default)(a)[0].scrollHeight
        }

        function r() {
            if ((0, n.default)("input#cartItems").length > 0) {
                var e = "";
                (0, n.default)(".cart-list .responsive-table-row").each((function() {
                    e += "<strong>" + (0, n.default)(this).find(".product-title").text().trim() + "</strong>", e += "<ul>", (0, n.default)(this).find(".line-item-property").each((function() {
                        (0, n.default)(this).text().includes("Ship Estimate"), e += "<li>" + (0, n.default)(this).text().trim().replace(/\s/g, " ") + "</li>"
                    })), e += "</ul>"
                })), (0, n.default)("input#cartItems").val(e)
            }
        }(0, o.focusHash)(), (0, o.bindInPageLinks)(), d.cookiesEnabled && (0, d.cookiesEnabled)() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")), document.addEventListener("DOMContentLoaded", (function() {
            var e = document.getElementsByTagName("body");
            e[0].classList ? e[0].classList.add("loaded") : e[0].className += " loaded"
        })), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)(".search-link").on("click", (function(e) {
                e.preventDefault(), (0, n.default)(".search-panel").toggleClass("active"), (0, n.default)("#Search-header").focus()
            })), (0, n.default)(".search-close").on("click", (function(e) {
                e.preventDefault(), (0, n.default)(".search-panel").toggleClass("active")
            }))
        })), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("body").hasClass("template-cart") && ((0, n.default)(".ajaxcart__qty--plus").click((function(e) {
                var a = (0, n.default)(this).parent().find(".ajaxcart__qty-num"),
                    t = Number((0, n.default)(a).val()),
                    o = Number((0, n.default)(this).parents(".responsive-table-row").data("variant")),
                    d = ((0, n.default)(this).parents(".responsive-table-row").data("inventory-policy"), (0, n.default)(this).parents(".responsive-table-row").data("inventory-qty")),
                    l = t + 1;
                l > d ? (0, n.default)(this).parents(".responsive-table-row").find(".max-qty-note").fadeIn("fast", (function() {
                    (0, n.default)(this).fadeOut(2e3)
                })) : CartJS.updateItemById(o, l, {}, {
                    success: function(e, t, o) {
                        (0, n.default)(a).val(l), jQuery.getJSON("/cart.js", (function(e) {
                            (0, n.default)("#CartItemCount").text(e.item_count), (0, n.default)(".subtotal-price").text((0, s.formatMoney)(e.total_price, theme.moneyFormat))
                        }))
                    },
                    error: function(e, a, t) {
                        alert("Sorry, there has been an error updating this item in the cart"), console.log("Error"), console.log(e), console.log(a), console.log(t)
                    }
                }), r()
            })), (0, n.default)(".ajaxcart__qty--minus").click((function(e) {
                var a = (0, n.default)(this).parent().find(".ajaxcart__qty-num"),
                    t = Number((0, n.default)(a).val()),
                    o = Number((0, n.default)(this).parents(".responsive-table-row").data("variant")),
                    d = ((0, n.default)(this).parents(".responsive-table-row").data("inventory-policy"), (0, n.default)(this).parents(".responsive-table-row").data("inventory-qty"), t - 1);
                CartJS.updateItemById(o, d, {}, {
                    success: function(e, t, o) {
                        (0, n.default)(a).val(d), jQuery.getJSON("/cart.js", (function(e) {
                            (0, n.default)("#CartItemCount").text(e.item_count), (0, n.default)(".subtotal-price").text((0, s.formatMoney)(e.total_price, theme.moneyFormat))
                        }))
                    },
                    error: function(e, a, t) {
                        alert("Sorry, there has been an error updating this item in the cart"), console.log("Error"), console.log(e), console.log(a), console.log(t)
                    }
                }), 0 === d && (0, n.default)(this).parents(".responsive-table-row").fadeOut("fast", (function() {
                    (0, n.default)(this).remove(), jQuery.getJSON("/cart.js", (function(e) {
                        0 === e.item_count && (0, n.default)(".responsive-table").html((0, n.default)(".empty-cart-placeholder").html())
                    }))
                })), r()
            })), (0, n.default)(".remove").click((function(e) {
                var a = (0, n.default)(this).parent().find(".ajaxcart__qty-num"),
                    t = (Number((0, n.default)(a).val()), Number((0, n.default)(this).parents(".responsive-table-row").data("variant")));
                (0, n.default)(this).parents(".responsive-table-row").data("inventory-policy"), (0, n.default)(this).parents(".responsive-table-row").data("inventory-qty"), CartJS.updateItemById(t, 0, {}, {
                    success: function(e, t, o) {
                        (0, n.default)(a).val(0), jQuery.getJSON("/cart.js", (function(e) {
                            (0, n.default)("#CartItemCount").text(e.item_count), (0, n.default)(".subtotal-price").text((0, s.formatMoney)(e.total_price, theme.moneyFormat))
                        }))
                    },
                    error: function(e, a, t) {
                        alert("Sorry, there has been an error updating this item in the cart"), console.log("Error"), console.log(e), console.log(a), console.log(t)
                    }
                }), (0, n.default)(this).parents(".responsive-table-row").fadeOut("fast", (function() {
                    (0, n.default)(this).remove(), jQuery.getJSON("/cart.js", (function(e) {
                        0 === e.item_count && (0, n.default)(".responsive-table").html((0, n.default)(".empty-cart-placeholder").html())
                    }))
                })), r()
            })), (0, n.default)(".cart-checkout").outerHeight > (0, n.default)(".cart-list").outerHeight && (0, n.default)(".cart-list").height((0, n.default)(".cart-checkout").outerHeight))
        })), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("section.site-header").hasClass("announcement-bar-active") && (0, n.default)("body").addClass("announcement-bar-active"), (0, n.default)(".announcement-bar-close").click((function(e) {
                e.preventDefault(), (0, n.default)(".site-header").hasClass("announcement-bar-active") && (0, n.default)(".site-header").removeClass("announcement-bar-active"), (0, n.default)("body").hasClass("announcement-bar-active") && (0, n.default)("body").removeClass("announcement-bar-active")
            }))
        })), document.addEventListener("DOMContentLoaded", (function() {
            // Mobile Menu 
            (0, n.default)("button.hamburger").on("click", (function() {
                (0, n.default)(this).toggleClass("is-active"), (0, n.default)('header[role="banner"]').toggleClass("mobile-active"), (0, n.default)("body").toggleClass("mobile-active")
            }))
        })), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)(window).width() <= 973 && (0, n.default)("a.has_submenu").on("click", (function(e) {
                e.preventDefault(), (0, n.default)(this).parent().toggleClass("is-active"), (0, n.default)(this).parent().hasClass("is-active") && ((0, n.default)(".menu .is-active").removeClass("is-active"), (0, n.default)(this).parent().addClass("is-active"))
            }))
        })), document.addEventListener("DOMContentLoaded", (function() {
            if ( $(window).width() <= 973 ) {
                $('a.sub_has_submenu').on('click', function(e){
                    e.preventDefault();
                    $(this).closest('.second-level-category').toggleClass('is-active');
                });
            }
        })), 
          document.addEventListener("DOMContentLoaded", (function() {
            if ((0, n.default)("body").hasClass("template-index")) {
                var e = (0, n.default)("#home-banner").data("delay");
                setInterval((function() {
                    var e = (0, n.default)(".home-banner .banner-slide.active").next(),
                        a = (0, n.default)(".home-banner .banner-slide").first();
                    0 == e.length ? ((0, n.default)(a).addClass("activating"), (0, n.default)(".home-banner .banner-slide").removeClass("active"), (0, n.default)(".home-banner .banner-slide.activating").addClass("active").removeClass("activating")) : ((0, n.default)(e).addClass("activating"), (0, n.default)(".home-banner .banner-slide").removeClass("active"), (0, n.default)(".home-banner .banner-slide.activating").addClass("active").removeClass("activating"))
                }), e)
            }
        })), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("#terms-toggle").on("click", (function(e) {
                e.preventDefault(), (0, n.default)(this).toggleClass("active"), (0, n.default)("#terms-copy").toggleClass("active")
            }))
        })), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("body").hasClass("template-collection") && (0, n.default)("body").is("#trnk-swatches") && ((0, n.default)("#shopify-section-trnk-selector")[0].scrollHeight, (0, n.default)("#shopify-section-trnk-selector").height(""), (0, n.default)("#shopify-section-trnk-selector").height((0, n.default)("#shopify-section-trnk-selector")[0].scrollHeight))
        })), (0, n.default)("body").hasClass("template-product") && (0, n.default)(".related-products-feed").length > 0 && (window.addEventListener("DOMContentLoaded", l(".related-products-feed")), window.addEventListener("resize", l(".related-products-feed"))), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("body").hasClass("template-cart") && r()
        })), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("label.add-to-calendar-checkbox").on("click", (function(e) {
                e.preventDefault(), 0 == (0, n.default)(this).next("input.add-to-calendar-checkbox").prop("checked") ? (0, n.default)(this).next("input.add-to-calendar-checkbox").prop("checked", !0) : 1 == (0, n.default)(this).next("input.add-to-calendar-checkbox").prop("checked") && (0, n.default)(this).next("input.add-to-calendar-checkbox").prop("checked", !1)
            }))
        })), document.addEventListener("scroll", (function(e) {
            window.pageYOffset > 20 ? (0, n.default)("body.page-rend .site-header, body.page-trnk-seasonal .site-header").addClass("visible") : (0, n.default)("body.page-rend .site-header, body.page-trnk-seasonal .site-header").removeClass("visible")
        }), {
            capture: !0,
            passive: !0
        }), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("body.page-rend .home-banner video, body.page-trnk-seasonal .home-banner video").on("click", (function(e) {
                e.preventDefault();
                var a = document.getElementById("rend-hero-video");
                (0, n.default)(this).hasClass("playing") ? ((0, n.default)("#rend-hero-video").removeClass("playing"), (0, n.default)("#rend-hero-video").addClass("paused"), (0, n.default)(".responsive-video__wrapper").addClass("paused"), a.pause(), console.log("pause")) : (0, n.default)(this).hasClass("paused") ? ((0, n.default)("#rend-hero-video").removeClass("paused"), (0, n.default)("#rend-hero-video").addClass("playing"), (0, n.default)(".responsive-video__wrapper").removeClass("paused"), a.play(), console.log("play")) : ((0, n.default)(".responsive-video__wrapper").removeClass("init"), (0, n.default)("#rend-hero-video").removeClass("initial"), (0, n.default)("#rend-hero-video").addClass("playing"), a.play(), console.log("reveal"))
            })), (0, n.default)("body.page-rend .video-init-container a, body.page-trnk-seasonal .video-init-container a").on("click", (function(e) {
                e.preventDefault();
                var a = document.getElementById("rend-hero-video");
                (0, n.default)("body.page-rend .home-banner video").hasClass("playing") ? ((0, n.default)("#rend-hero-video").removeClass("playing"), (0, n.default)("#rend-hero-video").addClass("paused"), (0, n.default)(".responsive-video__wrapper").addClass("paused"), a.pause(), console.log("button pause")) : (0, n.default)("body.page-rend .home-banner video").hasClass("paused") ? ((0, n.default)("#rend-hero-video").removeClass("paused"), (0, n.default)("#rend-hero-video").addClass("playing"), (0, n.default)(".responsive-video__wrapper").removeClass("paused"), a.play(), console.log("buttton play")) : ((0, n.default)(".responsive-video__wrapper").removeClass("init"), (0, n.default)("#rend-hero-video").removeClass("initial"), (0, n.default)("#rend-hero-video").addClass("playing"), a.play(), console.log("button reveal")), document.getElementById("rend-hero-video").addEventListener("ended", (function(e) {
                    (0, n.default)(".responsive-video__wrapper").addClass("init"), (0, n.default)("#rend-hero-video").addClass("initial"), (0, n.default)("#rend-hero-video").removeClass("playing")
                }), !1)
            }))
        })), document.addEventListener("scroll", (function(e) {
            window.pageYOffset > 20 ? (0, n.default)("body.page-mien .site-header").addClass("visible") : (0, n.default)("body.page-mien .site-header").removeClass("visible")
        }), {
            capture: !0,
            passive: !0
        }), document.addEventListener("scroll", (function(e) {
            window.pageYOffset > 20 ? (0, n.default)("body.page-provenanced .site-header, body.page-trnk-seasonal .site-header").addClass("visible") : (0, n.default)("body.page-provenanced .site-header, body.page-trnk-seasonal .site-header").removeClass("visible")
        }), {
            capture: !0,
            passive: !0
        }), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("body.page-provenanced .home-banner video, body.page-trnk-seasonal .home-banner video").on("click", (function(e) {
                e.preventDefault();
                var a = document.getElementById("rend-hero-video");
                (0, n.default)(this).hasClass("playing") ? ((0, n.default)("#rend-hero-video").removeClass("playing"), (0, n.default)("#rend-hero-video").addClass("paused"), (0, n.default)(".responsive-video__wrapper").addClass("paused"), a.pause(), console.log("pause")) : (0, n.default)(this).hasClass("paused") ? ((0, n.default)("#rend-hero-video").removeClass("paused"), (0, n.default)("#rend-hero-video").addClass("playing"), (0, n.default)(".responsive-video__wrapper").removeClass("paused"), a.play(), console.log("play")) : ((0, n.default)(".responsive-video__wrapper").removeClass("init"), (0, n.default)("#rend-hero-video").removeClass("initial"), (0, n.default)("#rend-hero-video").addClass("playing"), a.play(), console.log("reveal"))
            })), (0, n.default)("body.page-provenanced .video-init-container a, body.page-trnk-seasonal .video-init-container a").on("click", (function(e) {
                e.preventDefault();
                var a = document.getElementById("rend-hero-video");
                (0, n.default)("body.page-provenanced .home-banner video").hasClass("playing") ? ((0, n.default)("#rend-hero-video").removeClass("playing"), (0, n.default)("#rend-hero-video").addClass("paused"), (0, n.default)(".responsive-video__wrapper").addClass("paused"), a.pause(), console.log("button pause")) : (0, n.default)("body.page-rend .home-banner video").hasClass("paused") ? ((0, n.default)("#rend-hero-video").removeClass("paused"), (0, n.default)("#rend-hero-video").addClass("playing"), (0, n.default)(".responsive-video__wrapper").removeClass("paused"), a.play(), console.log("buttton play")) : ((0, n.default)(".responsive-video__wrapper").removeClass("init"), (0, n.default)("#rend-hero-video").removeClass("initial"), (0, n.default)("#rend-hero-video").addClass("playing"), a.play(), console.log("button reveal")), document.getElementById("rend-hero-video").addEventListener("ended", (function(e) {
                    (0, n.default)(".responsive-video__wrapper").addClass("init"), (0, n.default)("#rend-hero-video").addClass("initial"), (0, n.default)("#rend-hero-video").removeClass("playing")
                }), !1)
            }))
        })), document.addEventListener("scroll", (function(e) {
            window.pageYOffset > 20 ? (0, n.default)("body.page-resistance-resilience .site-header").addClass("visible") : (0, n.default)("body.page-resistance-resilience .site-header").removeClass("visible")
        }), {
            capture: !0,
            passive: !0
        }), document.addEventListener("DOMContentLoaded", (function() {
            (0, n.default)("body.page-resistance-resilience .home-banner video").on("click", (function(e) {
                e.preventDefault();
                var a = document.getElementById("rend-hero-video");
                (0, n.default)(this).hasClass("playing") ? ((0, n.default)("#rend-hero-video").removeClass("playing"), (0, n.default)("#rend-hero-video").addClass("paused"), (0, n.default)(".responsive-video__wrapper").addClass("paused"), a.pause(), console.log("pause")) : (0, n.default)(this).hasClass("paused") ? ((0, n.default)("#rend-hero-video").removeClass("paused"), (0, n.default)("#rend-hero-video").addClass("playing"), (0, n.default)(".responsive-video__wrapper").removeClass("paused"), a.play(), console.log("play")) : ((0, n.default)(".responsive-video__wrapper").removeClass("init"), (0, n.default)("#rend-hero-video").removeClass("initial"), (0, n.default)("#rend-hero-video").addClass("playing"), a.play(), console.log("reveal"))
            })), (0, n.default)("body.page-resistance-resilience .video-init-container a").on("click", (function(e) {
                e.preventDefault();
                var a = document.getElementById("rend-hero-video");
                (0, n.default)("body.page-resistance-resilience .home-banner video").hasClass("playing") ? ((0, n.default)("#rend-hero-video").removeClass("playing"), (0, n.default)("#rend-hero-video").addClass("paused"), (0, n.default)(".responsive-video__wrapper").addClass("paused"), a.pause(), console.log("button pause")) : (0, n.default)("body.page-rend .home-banner video").hasClass("paused") ? ((0, n.default)("#rend-hero-video").removeClass("paused"), (0, n.default)("#rend-hero-video").addClass("playing"), (0, n.default)(".responsive-video__wrapper").removeClass("paused"), a.play(), console.log("buttton play")) : ((0, n.default)(".responsive-video__wrapper").removeClass("init"), (0, n.default)("#rend-hero-video").removeClass("initial"), (0, n.default)("#rend-hero-video").addClass("playing"), a.play(), console.log("button reveal")), document.getElementById("rend-hero-video").addEventListener("ended", (function(e) {
                    (0, n.default)(".responsive-video__wrapper").addClass("init"), (0, n.default)("#rend-hero-video").addClass("initial"), (0, n.default)("#rend-hero-video").removeClass("playing")
                }), !1)
            }))
        }))
    },
    45: function(e, a, t) {}
});

// Still
document.addEventListener('scroll', (evt) => {
    if (window.pageYOffset > 20 ) {
        $('body.page-still .site-header').addClass('visible');
    } else {
        $('body.page-still .site-header').removeClass('visible');
    }
}, {
    capture: true,
    passive: true
});

// Still
document.addEventListener('DOMContentLoaded', () => {
  $('body.page-still .home-banner video').on('click', function(e){
      e.preventDefault();
      var rend_hero = document.getElementById("rend-hero-video");
      if ( $(this).hasClass('playing') ) {
          $('#rend-hero-video').removeClass('playing');
          $('#rend-hero-video').addClass('paused');
          $('.responsive-video__wrapper').addClass('paused');
          rend_hero.pause();
          console.log('pause');
      } else if ( $(this).hasClass('paused') ) {
          $('#rend-hero-video').removeClass('paused');
          $('#rend-hero-video').addClass('playing');
          $('.responsive-video__wrapper').removeClass('paused');
          rend_hero.play();
          console.log('play');
      } else {
          $('.responsive-video__wrapper').removeClass('init');
          $('#rend-hero-video').removeClass('initial');
          $('#rend-hero-video').addClass('playing');
          rend_hero.play();
          console.log('reveal');
      }
  });
  $('body.page-still .video-init-container a').on('click', function(e){
    e.preventDefault();
    var rend_hero = document.getElementById("rend-hero-video");
    if ( $('body.page-still .home-banner video').hasClass('playing') ) {
        $('#rend-hero-video').removeClass('playing');
        $('#rend-hero-video').addClass('paused');
        $('.responsive-video__wrapper').addClass('paused');
        rend_hero.pause();
        console.log('button pause');
    } else if ( $('body.page-rend .home-banner video').hasClass('paused') ) {
        $('#rend-hero-video').removeClass('paused');
        $('#rend-hero-video').addClass('playing');
        $('.responsive-video__wrapper').removeClass('paused');
        rend_hero.play();
        console.log('buttton play');
    } else {
        $('.responsive-video__wrapper').removeClass('init');
        $('#rend-hero-video').removeClass('initial');
        $('#rend-hero-video').addClass('playing');
        rend_hero.play();
        console.log('button reveal');
    }
    document.getElementById('rend-hero-video').addEventListener('ended',myHandler,false);
    function myHandler(e) {
      $('.responsive-video__wrapper').addClass('init');
      $('#rend-hero-video').addClass('initial');
      $('#rend-hero-video').removeClass('playing');
    }
  });
});
  

// Chosen
document.addEventListener('scroll', (evt) => {
    if (window.pageYOffset > 20 ) {
        $('body.page-chosen .site-header').addClass('visible');
    } else {
        $('body.page-chosen .site-header').removeClass('visible');
    }
}, {
    capture: true,
    passive: true
});


// Chosen
document.addEventListener('DOMContentLoaded', () => {
    $('body.page-chosen .home-banner video').on('click', function(e){
        e.preventDefault();
        var rend_hero = document.getElementById("rend-hero-video");
        if ( $(this).hasClass('playing') ) {
            $('#rend-hero-video').removeClass('playing');
            $('#rend-hero-video').addClass('paused');
            $('.responsive-video__wrapper').addClass('paused');
            rend_hero.pause();
            console.log('pause');
        } else if ( $(this).hasClass('paused') ) {
            $('#rend-hero-video').removeClass('paused');
            $('#rend-hero-video').addClass('playing');
            $('.responsive-video__wrapper').removeClass('paused');
            rend_hero.play();
            console.log('play');
        } else {
            $('.responsive-video__wrapper').removeClass('init');
            $('#rend-hero-video').removeClass('initial');
            $('#rend-hero-video').addClass('playing');
            rend_hero.play();
            console.log('reveal');
        }
    });
    $('body.page-chosen .video-init-container a').on('click', function(e){
      e.preventDefault();
      var rend_hero = document.getElementById("rend-hero-video");
      if ( $('body.page-chosen .home-banner video').hasClass('playing') ) {
          $('#rend-hero-video').removeClass('playing');
          $('#rend-hero-video').addClass('paused');
          $('.responsive-video__wrapper').addClass('paused');
          rend_hero.pause();
          console.log('button pause');
      } else if ( $('body.page-rend .home-banner video').hasClass('paused') ) {
          $('#rend-hero-video').removeClass('paused');
          $('#rend-hero-video').addClass('playing');
          $('.responsive-video__wrapper').removeClass('paused');
          rend_hero.play();
          console.log('buttton play');
      } else {
          $('.responsive-video__wrapper').removeClass('init');
          $('#rend-hero-video').removeClass('initial');
          $('#rend-hero-video').addClass('playing');
          rend_hero.play();
          console.log('button reveal');
      }
      document.getElementById('rend-hero-video').addEventListener('ended',myHandler,false);
      function myHandler(e) {
        $('.responsive-video__wrapper').addClass('init');
        $('#rend-hero-video').addClass('initial');
        $('#rend-hero-video').removeClass('playing');
      }
    });
  });

// const $currentActive = $('.banner-slide.banner-image.active');
// $currentActive.removeClass('active');

// // Find the next three .banner-image elements within the .banner-slide
// const $nextBannerImages = $currentActive.nextAll('.banner-image').slice(0, 3);

// if ($nextBannerImages.length > 0) {
//   $nextBannerImages.each(function () {
//     $(this).addClass('active');

//     // Apply the specified CSS properties to each .active element
//     $(this).css({
//       'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
//     });
//   });
// }




// function moveNextThreeElements() {
//   const $currentActive = $('.banner-slide.banner-image.active');
//   $currentActive.removeClass('active');

//   // Find the next three .banner-image elements within the .banner-slide
//   const $nextBannerImages = $currentActive.nextAll('.banner-image').slice(0, 3);

//   if ($nextBannerImages.length > 0) {
//     $nextBannerImages.each(function () {
//       $(this).addClass('active');

//       // Apply the specified CSS properties to each .active element
//       $(this).css({
//         'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
//       });
//     });
//   } else {
//     // If there are no more .banner-image elements, move back to the first three
//     const $firstThreeBannerImages = $('.banner-slide.banner-image').slice(0, 3);
//     $firstThreeBannerImages.addClass('active');

//     // Apply the specified CSS properties to each .active element
//     $firstThreeBannerImages.css({
//       'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
//     });
//   }

//   // Call the function again after a delay of 8000ms (8 seconds)
//   setTimeout(moveNextThreeElements, 8000);
// }

// // Call moveNextThreeElements initially to start the loop
// moveNextThreeElements();

// // Function to remove the "active" class from all .banner-slide.banner-image elements
// function removeActiveClass() {
//   $('.banner-slide.banner-image').removeClass('active');
// }

// // Function to select and apply "active" class to the first .banner-slide.banner-image element
// function selectFirstBannerImage() {
//   const $firstBannerImage = $('.banner-slide.banner-image').first();
//   $firstBannerImage.addClass('active');

//   // Apply the specified CSS properties to the .active element
//   $firstBannerImage.css({
//     'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
//   });
// }

// // Document ready function
// $(document).ready(function() {
//   // Remove the "active" class from .banner-slide.banner-image elements on document load
//   removeActiveClass();

//   // Select and apply "active" class to the first .banner-slide.banner-image element
//   selectFirstBannerImage();

//   // Start the slideshow
//   showNextThreeImages();
// });

//Slideshow function
function showNextThreeImages() {
  const $currentActive = $('.banner-slide.banner-image.active');
   // $currentActive.css({
   //    'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
   //    // Add other CSS properties here if needed
   //  });
  $currentActive.removeClass('active');

  // Find the next three .banner-image elements within the .banner-slide
  const $nextBannerImages = $currentActive.nextAll('.banner-image').slice(0, 4);

  if ($nextBannerImages.length > 0) {
    // Add the "active" class to the next .banner-image element
    $nextBannerImages.first().addClass('active');

    // Apply the specified CSS properties to the .active element
    $nextBannerImages.first().css({
      'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
    });
  } else {
    // If there are no more .banner-image elements, move back to the first three
    const $firstThreeBannerImages = $('.banner-slide.banner-image').slice(0, 4);
    $firstThreeBannerImages.first().addClass('active');

    // Apply the specified CSS properties to the .active element
    $firstThreeBannerImages.first().css({
      'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
    });
  }

  // Call the function again after 8000ms (8 seconds)
  setTimeout(showNextThreeImages, 8000);
}


// function showNextThreeImages() {
//     const $currentActive = $('.banner-slide.banner-image.active');

//     // Apply the specified CSS properties to the .active element
//     $currentActive.css({
//       'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
//       // Add other CSS properties here if needed
//     });

//     // Remove the "active" class from the current active element
//     $currentActive.removeClass('active');

//     // Find the next three .banner-image elements within the .banner-slide
//     const $nextBannerImages = $currentActive.nextAll('.banner-slide.banner-image').slice(0, 4);

//     if ($nextBannerImages.length > 0) {
//       // Add the "active" class to the next .banner-image element
//       $nextBannerImages.first().addClass('active');
//     } else {
//       // If there are no more .banner-image elements, move back to the first three
//       const $firstThreeBannerImages = $('.banner-slide.banner-image').slice(0, 4);
//       $firstThreeBannerImages.first().addClass('active');
//     }

//     // Call the function again after 8000ms (8 seconds)
//     setTimeout(showNextThreeImages, 8000);
//   }

//   // Start the slider after a delay of 8 seconds
//   setTimeout(showNextThreeImages, 8000);

// function moveNextThreeElements() {
//   const $currentActive = $('.banner-slide.banner-image.active');
//   $currentActive.removeClass('active');

//   // Find the next three .banner-image elements within the .banner-slide
//   const $nextBannerImages = $currentActive.nextAll('.banner-image').slice(0, 3);

//   if ($nextBannerImages.length > 0) {
//     $nextBannerImages.each(function () {
//       $(this).addClass('active');

//       // Apply the specified CSS properties to each .active element
//       $(this).css({
//         'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
//       });
//     });
//   } else {
//     // If there are no more .banner-image elements, move back to the first three
//     const $firstThreeBannerImages = $('.banner-slide.banner-image').slice(0, 3);
//     $firstThreeBannerImages.addClass('active');

//     // Apply the specified CSS properties to each .active element
//     $firstThreeBannerImages.css({
//       'transition': 'opacity 4250ms ease-in-out, transform 4250ms ease-in-out !important'
//     });
//   }

//   // Call the function again after a delay of 8000ms (8 seconds)
//   setTimeout(moveNextThreeElements, 8000);
// }

// // Call moveNextThreeElements initially to start the loop
// moveNextThreeElements();
